// custom-high-capacity-swiper.js
(function() {
  'use strict';

  /**
   * High Capacity Swiper - 优化版
   * 从 data-* 属性读取配置，支持多实例
   */
  class HighCapacitySwiper {
    constructor(container) {
      this.container = container;
      this.swiper = null;
      this.observer = null;
      
      this.init();
    }

    init() {
      if (!this.container) return;

      // 如果已经初始化，跳过
      if (this.container.swiper) {
        this.swiper = this.container.swiper;
        return;
      }

      // IntersectionObserver 延迟初始化
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.swiper) {
              this.createSwiper();
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px',
          threshold: 0.01,
        });
        this.observer.observe(this.container);
      } else {
        this.createSwiper();
      }
    }

    createSwiper() {
      if (!this.container || this.swiper) return;

      if (typeof Swiper === 'undefined') {
        console.warn('⚠️ Swiper library not loaded');
        return;
      }

      this._buildSwiper();
    }

    _buildSwiper() {
      const el = this.container;
      
      // 从 data-* 属性读取配置（会自动解析类型）
      const getData = (key, fallback) => {
        const value = el.dataset[key];
        if (value === undefined) return fallback;
        if (value === 'true') return true;
        if (value === 'false') return false;
        if (!isNaN(value) && value.trim() !== '') return Number(value);
        return value;
      };

      // 获取分页和导航元素
      const paginationEl = el.querySelector('.swiper-pagination');
      const prevEl = el.querySelector('.custom-arrow-prev');
      const nextEl = el.querySelector('.custom-arrow-next');

      const config = {
        slidesPerView: getData('slidesPerView', 1.2),
        spaceBetween: getData('spaceBetween', 16),
        loop: getData('enableLoop', false),
        autoplay: getData('enableAutoplay', false) ? {
          delay: getData('autoplayDelay', 5000),
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: getData('slidesPerViewDesktop', 1.2),
            spaceBetween: getData('spaceBetweenDesktop', 16),
          },
          1024: {
            slidesPerView: getData('slidesPerViewLarge', 1.5),
            spaceBetween: getData('spaceBetweenLarge', 24),
          }
        }
      };

      if (paginationEl) {
        config.pagination = { el: paginationEl, clickable: true };
      }

      if (prevEl && nextEl) {
        config.navigation = { nextEl, prevEl };
      }

      this.swiper = new Swiper(el, config);
      el.swiper = this.swiper;
      
      console.log('✅ HighCapacitySwiper initialized');
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        if (this.container) {
          this.container.swiper = null;
        }
      }
    }
  }

  // ============================================================
  // 自动初始化所有实例
  // ============================================================
  function initAllSliders() {
    const containers = document.querySelectorAll('#high-capacity-section .swiper[data-section-id]');
    
    containers.forEach(container => {
      if (container._swiperInstance) return;
      container._swiperInstance = new HighCapacitySwiper(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // ============================================================
  // Shopify 事件处理
  // ============================================================
  document.addEventListener('shopify:section:unload', function(e) {
    const container = document.querySelector(`#high-capacity-section .swiper[data-section-id="${e.detail.sectionId}"]`);
    if (container && container._swiperInstance) {
      container._swiperInstance.destroy();
      delete container._swiperInstance;
    }
  });

  document.addEventListener('shopify:section:load', function(e) {
    const container = document.querySelector(`#high-capacity-section .swiper[data-section-id="${e.detail.sectionId}"]`);
    if (container && !container._swiperInstance) {
      container._swiperInstance = new HighCapacitySwiper(container);
    }
  });

})();